import axios from "axios";

const API_URL = "https://api.suuplink.suave.ppg.br/api/";

const requestAvatarUpload = async ({ avatarData, admin, idId, method }) => {
  return await axios({
    method,
    url: API_URL + `admin/pages/${idId}/upload-avatar`,
    data: avatarData,
    headers: {
      "x-access-token": admin.accessToken,
    },
  });
};

const putAvatar = async ({ avatarData, admin, idId }) => {
  try {
    return await requestAvatarUpload({
      avatarData,
      admin,
      idId,
      method: "put",
    });
  } catch (error) {
    if (error?.response?.status === 404) {
      return await requestAvatarUpload({
        avatarData,
        admin,
        idId,
        method: "post",
      });
    }

    throw error;
  }
};

const avatarService = {
  putAvatar,
};

export default avatarService;
